/**
 * Action types for firmware announcement banner functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle list of captive portals.
 */

// Get captive portals constants
export const MAINTENANCE_INSTANCE_REQUEST_GET = 'MAINTENANCE_INSTANCE_REQUEST_GET';
export const MAINTENANCE_INSTANCE_RESPONSE_GET_SUCCESS = 'MAINTENANCE_INSTANCE_RESPONSE_GET_SUCCESS';
export const MAINTENANCE_INSTANCE_RESPONSE_GET_FAIL = 'MAINTENANCE_INSTANCE_RESPONSE_GET_FAIL';

// Announcement banner close trigger
export const ANNOUNCEMENT_BANNER_CLOSE_TRIGGER = 'ANNOUNCEMENT_BANNER_CLOSE_TRIGGER';

export const RESET_ANNOUNCEMENT_BANNER_CLOSE = 'RESET_ANNOUNCEMENT_BANNER_CLOSE';